// config/agingTableFilters.ts

import { FilterConfig } from "../../../../components/Tables/advancedRecord/FilterBar";
import { DropdownDTO } from "../../../../types/common/DropdownDTO";

export const getAgingTableFilters = (
  customersDropdown: DropdownDTO[]
): FilterConfig[] => {
  return [
    /**
     * 👤 Cliente
     */
    {
      name: "customerId",
      label: "Cliente",
      type: "searchSelect",
      options: customersDropdown,
      colSpan: 6,
    },

    /**
     * 🚨 Solo alto riesgo
     */
    // {
    //   name: "highRiskOnly",
    //   label: "Solo alto riesgo (+90 días)",
    //   type: "checkbox",
    //   colSpan: 6,
    // },
  ];
};